<template>
  <PagePaper>
    <div class="d-flex justify-end align-center mr-3">
      <div class="mb-4 mr-4">
        <DateRangeInput type="month" :selectedDates="selectedDates" @update="updateDates" />
      </div>
    </div>
    <div>
      <v-data-table
        :loading-text="table.loadingText"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30]
        }"
        class="tableReport"
      >
        <template v-slot:[`item.income`]="{ item }">
          {{ item.income }}
        </template>
        <template v-slot:[`header.subtotal`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.subtotal`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.subtotal) }}</div>
        </template>
        <template v-slot:[`header.tax`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.iva) }}</div>
        </template>
        <template v-slot:[`header.total`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.total) }}</div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <!-- // Todo: conditionate render -->
          <!-- <div v-if="item.source === 'receipt'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  target="_blank"
                  :href="downloadReport(item._id)"
                  class="blueButton"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.incomeReport.table.downloadReport') }}</span>
            </v-tooltip>
          </div> -->
          <div v-if="item.income === 'Cobranza'">
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  class="mr-3"
                  v-on="on"
                  target="_blank"
                  dark
                  fab
                  :href="exportRoute"
                  x-small
                  depressed
                  color="secondary">
                  <v-icon color="white">mdi-application-export</v-icon>
                </v-btn>
              </template>
              <span>Descargar estado de cuenta</span>
            </v-tooltip>
          </div>
          <div v-if="item.income === 'Venta factura clientes'">
            <v-tooltip bottom>
              <template
                v-slot:activator="{ on }">
                <v-btn
                  class="mr-3"
                  v-on="on"
                  target="_blank"
                  dark
                  fab
                  :href="downloadLink(item)"
                  x-small
                  depressed
                  color="secondary">
                  <v-icon color="white">mdi-file-download-outline</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('income.billing.invoices.tableInvoices.buttonDownloadCsvTooltip') }}</span>
            </v-tooltip>
          </div>
          <div v-if="item.downloadXML">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  color="secondary"
                  :disabled="item.total <= 0"
                  @click="downloadInvoice()"
                >
                  <v-icon>mdi-file-xml</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.incomeReport.table.downloadInvoice') }}</span>
            </v-tooltip>
          </div>
        </template>

        <!-- <template v-slot:footer="">
          <Pagination
            :itemsPerPage="table.options.itemsPerPage"
            :page="table.options.page"
            :total="totalRecords"
          />
        </template> -->
      </v-data-table>

      <v-data-table
        :loading-text="incomingsTable.loadingText"
        :loading="incomingsTable.loading"
        :headers="incomingsTable.headers"
        :items="incomingsTable.data"
        :options="incomingsTable.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30]
        }"
        class="tableReport"
      >
        <template v-slot:[`item.income`]="{ item }">
          {{ item.income }}
        </template>
        <template v-slot:[`header.subtotal`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.subtotal`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.subtotal) }}</div>
        </template>
        <template v-slot:[`header.tax`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.iva) }}</div>
        </template>
        <template v-slot:[`header.total`]="{ header }">
          <div class="text-right">{{ header.text }}</div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          <div class="text-right">{{ formatCurrency(item.total) }}</div>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <!-- // Todo: conditionate render -->
          <div v-if="item.source === 'receipt'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  target="_blank"
                  :href="downloadReport(item._id)"
                  class="blueButton"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.incomeReport.table.downloadReport') }}</span>
            </v-tooltip>
          </div>
          <div v-if="item.income === 'Otras ventas con factura'">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  target="_blank"
                  @click="openOtherInvoices(item)"
                  class="blueButton"
                >
                  <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
              </template>
              <span>Ver Otras facturas</span>
            </v-tooltip>
          </div>
          <div v-if="item.downloadXML">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  x-small
                  depressed
                  color="secondary"
                  :disabled="item.total <= 0"
                  @click="downloadXML(item)"
                >
                  <v-icon>mdi-receipt</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('management.incomeReport.table.downloadXML') }}</span>
            </v-tooltip>
          </div>
        </template>

        <!-- <template v-slot:footer="">
          <Pagination
            :itemsPerPage="table.options.itemsPerPage"
            :page="table.options.page"
            :total="totalRecords"
          />
        </template> -->
      </v-data-table>
    </div>
    <OtherInvoices ref="otherInvoices" :selectedDates="selectedDates"/>
  </PagePaper>
</template>

<script>
import DateRangeInput from '@/components/elements/DateRangeInput'
// import Pagination from '@/components/elements/Pagination'
import PagePaper from '@/components/elements/PagePaper'
import formatCurrency from '@/utils/formatCurrency'
import OtherInvoices from '@/components/sidePanels/OtherInvoices'

export default {
  name: 'IncomeReport',
  components: {
    DateRangeInput,
    // Pagination,
    PagePaper,
    OtherInvoices
  },
  data () {
    return {
      selectedDates: [],
      table: {
        loadingText: this.$i18n.t('management.incomeReport.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('management.incomeReport.table.headers.income'), value: 'income', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.subtotal'), value: 'subtotal', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.tax'), value: 'tax', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.total'), value: 'total', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      incomingsTable: {
        loadingText: this.$i18n.t('management.incomeReport.table.loadingText'),
        loading: false,
        headers: [
          { text: this.$i18n.t('management.incomeReport.table.headers.income'), value: 'income', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.subtotal'), value: 'subtotal', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.tax'), value: 'tax', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.total'), value: 'total', sortable: false },
          { text: this.$i18n.t('management.incomeReport.table.headers.actions'), value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          groupBy: [],
          groupDesc: [],
          itemsPerPage: 10,
          multiSort: false,
          mustSort: false,
          page: 1,
          sortBy: [''],
          sortDesc: []
        }
      },
      otherInvoicesDetailsPanelOpen: false
    }
  },
  computed: {
    totalRecords () {
      return this.table.data.length
    },
    exportRoute () {
      const dates = this.selectedDates.length === 2
        ? [this.selectedDates[0], this.selectedDates[1]]
        : [null, null]
      let url = process.env.VUE_APP_API_URL
      url += `/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/income-export`
      url += `?access_token=${this.$store.state.login.token}`
      if (this.selectedDates.length) url += `&createdAt>=${dates[0]}&createdAt<=${dates[1]}`
      return url
    }
  },
  watch: {
    selectedDates (val) {
      this.selectedDates = val
    }
  },
  methods: {
    downloadInvoice: async function () {
      const params = {
        restaurant: this.$store.state.currentRestaurant.data._id,
        startDate: this.selectedDates[0],
        endDate: this.selectedDates[1]
      }
      const response = await this.$api.get(`/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/download-invoice`, params)
      var element = document.createElement('a')
      element.setAttribute('href', 'data:text/xml;charset=utf-8,' + encodeURIComponent(response.content))
      element.setAttribute('download', `factura-global`)

      element.style.display = 'none'
      document.body.appendChild(element)

      element.click()

      document.body.removeChild(element)
    },
    async downloadXML () {
      const startDate = this.$moment(this.selectedDates[0])
      const endDate = this.$moment(this.selectedDates[1])
      try {
        await this.$api.get(`/v1/reports/${this.$store.state.currentRestaurant.data._id}/accounting/export-other-sales-with-invoice?restaurant=${this.$store.state.currentRestaurant.data._id}&issuedAt>=${startDate.startOf('day').toISOString() || ''}&issuedAt<=${endDate.endOf('day').toISOString() || ''}&incomeKind=income`)
        this.$toasted.show('Se enviará a su correo el link para descargar las facturas emitadas', { duration: 3000, type: 'success' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    // Todo: integrate api
    loadReports: async function () {
      if (this.selectedDates.length === 2) {
        const [startDate, endDate] = this.selectedDates
        const params = {
          'createdAt>': startDate,
          'createdAt<': endDate
        }
        const restauratId = this.$store.state.currentRestaurant.data._id
        this.table.loading = true
        this.incomingsTable.loading = true
        try {
          const response = await this.$api.get(`/v1/reports/${restauratId}/accounting/incomings`, params)
          const {
            invoicePosTotal,
            customerInvoicedTotal,
            otherSalesWithInvoice,
            globalTotal,
            transactionsWithInvoice,
            uncollectedInvoices,
            incomeTypes
          } = response
          const dataItems = []
          const incomingsDataItems = []
          dataItems.push({
            income: this.$i18n.t('management.incomeReport.table.incomes.invoicePosTotal'),
            downloadXML: true,
            ...invoicePosTotal
          })
          dataItems.push({
            income: this.$i18n.t('management.incomeReport.table.incomes.customerInvoicedTotal'),
            ...customerInvoicedTotal
          })
          dataItems.push({
            income: this.$i18n.t('management.incomeReport.table.incomes.globalTotal'),
            ...globalTotal
          })
          dataItems.push({
            income: this.$i18n.t('management.incomeReport.table.incomes.transactionsWithInvoice'),
            ...transactionsWithInvoice
          })
          // dataItems.push({
          //   income: this.$i18n.t('management.incomeReport.table.incomes.transactionsWithoutInvoice'),
          //   ...transactionsWithoutInvoice
          // })
          dataItems.push({
            income: this.$i18n.t('management.incomeReport.table.incomes.uncollectedInvoices'),
            ...uncollectedInvoices
          })
          incomingsDataItems.push({
            income: this.$i18n.t('management.incomeReport.table.incomes.otherSalesWithInvoice'),
            downloadXML: true,
            ...otherSalesWithInvoice
          })
          incomeTypes.forEach(({ type, ...rest }) => incomingsDataItems.push({ income: type, ...rest }))
          this.table.data = dataItems
          this.incomingsTable.data = incomingsDataItems
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.table.loading = false
        this.incomingsTable.loading = false
      }
    },
    updateDates (dates) {
      this.selectedDates = [ ...dates ]
      this.loadReports()
    },
    formatCurrency,
    // Todo: download file
    downloadReport (id) {
      // let url = `${process.env.VUE_APP_API_URL}/v1/invoices/${id}/download-invoice-pdf`
      // url += `?access_token=${this.$store.state.login.token}`

      // return url
    },
    openOtherInvoices () {
      this.otherInvoicesDetailsPanelOpen = true
      this.$refs.otherInvoices.open()
    },
    downloadLink (item) {
      return `${process.env.VUE_APP_API_URL}/v1/charges/pos/${item._id}/download?access_token=${this.$store.state.login.token}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .tableReport {
    th {
      font-size: 12px;
    }

    td {
      font-size: 12px;
    }
  }

  .blueButton {
    background-color: #0F6FFF !important;
    color: #fff !important;
  }
</style>
